// extracted by mini-css-extract-plugin
export default {"logoFullWidth":"Header_logoFullWidth__HjCpo"};